import { X } from "lucide-react";
import { WIZARD_WIDGET_W } from "./wizardPlacement";
import { useWizard } from "./wizardStore";

type Ring = { left: number; top: number; width: number; height: number };

// The pulsing ring and the step card are one object: the ring marks the click target,
// the card is the text that sits beside it. The finale card is a different component.
export function WizardStepCard(props: {
  step: number;
  lastStep: number;
  text: string;
  showNext: boolean;
  onAdvance?: () => void;
  pos: { left: number; top: number };
  ring: Ring | null;
}) {
  const { step, lastStep, text, showNext, onAdvance, pos, ring } = props;
  return (
    <>
      {/* the highlight — a pulsing ring on the CLICK TARGET (falls back to the anchor) */}
      {ring && (
        <div
          className="pointer-events-none fixed z-coach animate-pulse rounded border-2 border-accent"
          style={{
            left: ring.left - 4,
            top: ring.top - 4,
            width: ring.width + 8,
            height: ring.height + 8,
          }}
          aria-hidden
        />
      )}
      <div
        className="fixed z-pop rounded-lg border border-accent bg-surface p-3 shadow-2xl"
        style={{ left: pos.left, top: pos.top, width: WIZARD_WIDGET_W }}
        data-testid="wizard-widget"
      >
        <div className="flex items-start justify-between gap-2">
          <span className="text-[10px] font-semibold uppercase tracking-wide text-accent">
            Genius Rx Demo/Tutorial · {step} / {lastStep}
          </span>
          <button
            onClick={() => useWizard.getState().exit()}
            className="rounded p-0.5 text-muted hover:bg-hover"
            aria-label="Exit wizard"
          >
            <X size={13} />
          </button>
        </div>
        <p className="mt-1.5 text-[12px] leading-snug text-fg">{text}</p>
        {showNext && (
          <div className="mt-2 text-right">
            <button
              onClick={() => {
                onAdvance?.();
                useWizard.getState().next();
              }}
              className="rounded bg-accent px-3 py-1 text-xs font-medium text-canvas hover:bg-accent-hover"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </>
  );
}
